<div class="admin-dialog">
  <div class="admin-dialog__header">
    <div class="admin-dialog__header-left">
      <h2 class="admin-dialog__title">{{ data.title }}</h2>
    </div>
    <button mat-icon-button class="admin-dialog__close" mat-dialog-close aria-label="Close dialog" i18n-aria-label="@@shared.confirmDialog.button.close" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="admin-dialog__content" [innerText]="data.message"></div>

  <div class="admin-dialog__footer">
    <button
      type="button"
      mat-stroked-button
      (click)="onNoClick()"
      [hidden]="data?.hideNoButton"
    >
      {{ noButtonText }}
    </button>
    <button
      type="button"
      mat-flat-button
      [color]="variant === 'danger' ? 'warn' : 'primary'"
      [mat-dialog-close]="true"
      cdkFocusInitial
    >
      {{ confirmButtonText }}
    </button>
  </div>
</div>
